import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
export const HostSalon = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    aboutYou: '',
    inspiration: '',
    attendees: '',
    existingCommunity: '',
    communityDescription: '',
    promotionPlan: '',
    experience: '',
    eventDescription: '',
    engagementPlan: '',
    orientationAvailability: '',
    documentationWillingness: '',
    agreement: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xnngonyv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          aboutYou: '',
          inspiration: '',
          attendees: '',
          existingCommunity: '',
          communityDescription: '',
          promotionPlan: '',
          experience: '',
          eventDescription: '',
          engagementPlan: '',
          orientationAvailability: '',
          documentationWillingness: '',
          agreement: ''
        });
        setIsSubmitted(true);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3253" data-mp="1gx8hcmadhiec">
        <div className="container mx-auto px-4 py-16" data-id="element-3254" data-mp="1lv1kf6gdpwae">
          <div className="max-w-3xl mx-auto" data-id="element-3255" data-mp="17u7c0ntbzvbq">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-300 text-center" data-id="element-3256" data-mp="17vir3js88pi5">
              <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-3257" data-mp="1cubu2i9w0y42">
                Thank you for applying to host a Networking Salon!
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3258" data-mp="20l8xt7rj4p48">
                Your submission has been received, and our team will review it
                carefully. If selected, you'll receive hosting guidelines,
                support resources, and a short orientation session to help you
                plan your event.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3259" data-mp="2jhh2oagmqxz0">
                Together, we'll keep building spaces where connections turn into
                real opportunities.
              </p>
              <a href="https://wa.link/nc2jpo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-3260" data-mp="2xn0uvgcy7sza">
                <span className="mr-2" data-id="element-3261" data-mp="37br9brp6d9f6">💬</span>
                Chat With Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3262" data-mp="2envdep7fjljg">
      <section className="relative py-16 border-b border-gray-200" data-id="element-3263" data-mp="2eookxse7qf2n">
        <div className="absolute inset-0 z-0" data-id="element-3264" data-mp="2anux0z0rt09r">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="Host a Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3265" data-mp="2ap600wme63zt" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3266" data-mp="2jpkryetv2hca"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3267" data-mp="3uirv8yd0bkz">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3268" data-mp="3v3g4dftdsbzt">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3269" data-mp="3v50xr23ylow3">
              Host a Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3270" data-mp="29k4dojh3atr2">
              Create meaningful connections in your community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3271" data-mp="2ilc9muw4vihz">
        <div className="container mx-auto px-4" data-id="element-3272" data-mp="2imdjwx5bs0yn">
          <div className="max-w-3xl mx-auto" data-id="element-3273" data-mp="2iizibr4hjvs9">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-3274" data-mp="2njdrjchtpbrv">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-3275" data-mp="2siyppkp65g3j">
                Host a Networking Salon — Application Form
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3276" data-mp="2xb0axw4beh5p">
                We're excited that you'd like to host a Networking Salon!
                Hosting is more than putting people in a room — it's about
                curating meaningful conversations, creating safe spaces for
                connection, and upholding the values of The Networking Salon.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3277" data-mp="znpeq3gcjgg2">
                This short form helps us understand your readiness, your
                audience, and how you plan to make your salon special.
              </p>
              {error && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md mb-6" data-id="element-3278" data-mp="qmhsijr3u62c">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-3279" data-mp="1icw0y0gcmq6m">
                <div className="space-y-6" data-id="element-3280" data-mp="1if8f02izkgee">
                  <div data-id="element-3281" data-mp="1ebagnu1hj9me">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3282" data-mp="1ectwxkn55ko6">
                      Section 1: Host Information
                    </h3>
                    <div className="space-y-4" data-id="element-3283" data-mp="14miqnrfzize4">
                      <div data-id="element-3284" data-mp="14jmt4481ucq7">
                        <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-3285" data-mp="220v4orchwx2j">
                          Full Name <span className="text-gray-500" data-id="element-3286" data-mp="1xa4w758rwe3m">*</span>
                        </label>
                        <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3287" data-mp="2g657aarolmxn" />
                      </div>
                      <div data-id="element-3288" data-mp="27cikvb9d5w14">
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-3289" data-mp="2bfewgi0hkrvk">
                          Email Address <span className="text-gray-500" data-id="element-3290" data-mp="1xf475jetrlci">*</span>
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3291" data-mp="22fie0y4owp8y" />
                      </div>
                      <div data-id="element-3292" data-mp="1sivucco3o48i">
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-3293" data-mp="3isys4harl6cw">
                          Phone Number (WhatsApp Preferred){' '}
                          <span className="text-gray-500" data-id="element-3294" data-mp="3msr83f2hmesa">*</span>
                        </label>
                        <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3295" data-mp="1b5dx491id0rm" />
                      </div>
                      <div data-id="element-3296" data-mp="1g5s4dovac6ol">
                        <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-3297" data-mp="1g5ic1umrpnfq">
                          City, Country <span className="text-gray-500" data-id="element-3298" data-mp="1uxkcpgwnwkgt">*</span>
                        </label>
                        <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3299" data-mp="1pyz875adnemk" />
                      </div>
                      <div data-id="element-3300" data-mp="9iwo3qx28q2i">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3301" data-mp="9k7s9ruf3zu5">
                          What best describes you?{' '}
                          <span className="text-gray-500" data-id="element-3302" data-mp="3ftt8vvb6fxev">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3303" data-mp="3ju3gtdij4xwd">
                          {['Community Builder', 'Event Organizer', 'Business Owner / Founder', 'Professional / Creative', 'Student / Young Leader', 'Other'].map(option => <div key={option} className="flex items-center" data-id="element-3304" data-mp="3tky3uk3lo1iv">
                              <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3305" data-mp="2wu5lfft71xdx" />
                              <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-3306" data-mp="35uaqhjax0jox">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3307" data-mp="l6pedkwdjqux">
                        <label htmlFor="aboutYou" className="block text-gray-700 font-medium mb-1" data-id="element-3308" data-mp="q3fuu9c3cogv">
                          Tell us a bit about yourself{' '}
                          <span className="text-gray-500" data-id="element-3309" data-mp="2akyv9rp38b9p">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3310" data-mp="25noujfw90d6k">
                            Include your background, what you do, and what
                            drives your interest in community building.
                          </span>
                        </label>
                        <textarea id="aboutYou" name="aboutYou" value={formData.aboutYou} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3311" data-mp="1rviqgs6ddwnh" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3312" data-mp="1cz1f40y6ki0x">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3313" data-mp="1czt06hu5ixcy">
                      Section 2: Event Vision & Reach
                    </h3>
                    <div className="space-y-4" data-id="element-3314" data-mp="37danc3qn9s7g">
                      <div data-id="element-3315" data-mp="3h28hrn1dhwck">
                        <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-3316" data-mp="3h1fe4uxpnmyn">
                          What inspired you to host a Networking Salon?{' '}
                          <span className="text-gray-500" data-id="element-3317" data-mp="3r0xyhchj9ar8">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3318" data-mp="3qyboz7b30l6d">
                            We want to understand your motivation — what excites
                            you about this platform?
                          </span>
                        </label>
                        <textarea id="inspiration" name="inspiration" value={formData.inspiration} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3319" data-mp="2te7bylvkwu0u" />
                      </div>
                      <div data-id="element-3320" data-mp="2fkg0h7yaf02h">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3321" data-mp="2fjogyvhysssk">
                          Estimated Number of Attendees{' '}
                          <span className="text-gray-500" data-id="element-3322" data-mp="q4drcqvpjxz8">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3323" data-mp="uuu7iiqwxxpa">
                          {['20–50', '51–100', '101–200', 'More than 200'].map(option => <div key={option} className="flex items-center" data-id="element-3324" data-mp="g6g2c160xx5k">
                                <input type="radio" id={`attendees-${option}`} name="attendees" value={option} checked={formData.attendees === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3325" data-mp="l50vjgmuzgki" />
                                <label htmlFor={`attendees-${option}`} className="text-gray-700" data-id="element-3326" data-mp="1dsna1jxmk5m5">
                                  {option}
                                </label>
                              </div>)}
                        </div>
                      </div>
                      <div data-id="element-3327" data-mp="3kke7eiopnev4">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3328" data-mp="3kj34sm704d5l">
                          Do you have an existing community or audience you can
                          invite? <span className="text-gray-500" data-id="element-3329" data-mp="1v2r4ie7n4xv2">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3330" data-mp="1q47jcg0vfq3r">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3331" data-mp="1q6a7euigr95u">
                              <input type="radio" id={`existingCommunity-${option}`} name="existingCommunity" value={option} checked={formData.existingCommunity === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3332" data-mp="1lbefdud88lsq" />
                              <label htmlFor={`existingCommunity-${option}`} className="text-gray-700" data-id="element-3333" data-mp="17d6j7oo0loim">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.existingCommunity === 'Yes' && <div data-id="element-3334" data-mp="2wrbak0bns1ye">
                          <label htmlFor="communityDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3335" data-mp="2wqa1u2i47rju">
                            If yes, please describe your community or network
                            <span className="block text-sm text-gray-500" data-id="element-3336" data-mp="30a1u251u14nw">
                              Who are they? What connects them? How do you
                              normally engage with them?
                            </span>
                          </label>
                          <textarea id="communityDescription" name="communityDescription" value={formData.communityDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3337" data-mp="3e0dmy668r7g3" />
                        </div>}
                      <div data-id="element-3338" data-mp="2qb2xhkucczh9">
                        <label htmlFor="promotionPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3339" data-mp="2qat55qltqg8e">
                          How will you promote the event to ensure attendance?{' '}
                          <span className="text-gray-500" data-id="element-3340" data-mp="5ln7ut6uzgt7">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3341" data-mp="ak6uywx6uyn5">
                            Share your plan — social media, word of mouth,
                            partnerships, campus networks, etc.
                          </span>
                        </label>
                        <textarea id="promotionPlan" name="promotionPlan" value={formData.promotionPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3342" data-mp="1sid041qolgs4" />
                      </div>
                      <div data-id="element-3343" data-mp="22eg0b21z35cf">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3344" data-mp="1xi7qm46jo4cn">
                          Do you have experience organizing or co-hosting
                          events? <span className="text-gray-500" data-id="element-3345" data-mp="2baxd09pzjbaa">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3346" data-mp="279vank0ruj43">
                          {["Yes, I've organized events before", "Not yet, but I'm confident I can handle it"].map(option => <div key={option} className="flex items-center" data-id="element-3347" data-mp="2g98n8lk6znt1">
                              <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3348" data-mp="2ztfw2ewdii7y" />
                              <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-3349" data-mp="2pv9ujyehbe3m">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.experience === "Yes, I've organized events before" && <div data-id="element-3350" data-mp="2lw11kvr9jk94">
                          <label htmlFor="eventDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3351" data-mp="275ts35j8hbkk">
                            If yes, briefly describe one event you've hosted or
                            contributed to
                          </label>
                          <textarea id="eventDescription" name="eventDescription" value={formData.eventDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3352" data-mp="1y6zo2u3kpiwz" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-3353" data-mp="3v2jiapp785h9">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3354" data-mp="3v3uk4jz3335q">
                      Section 3: Alignment & Commitment
                    </h3>
                    <div className="space-y-4" data-id="element-3355" data-mp="rmm1hxwj7z9y">
                      <div data-id="element-3356" data-mp="rk9m9si5s30l">
                        <label htmlFor="engagementPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3357" data-mp="mnj14qrhyh8b">
                          The Networking Salon is about meaningful connection,
                          not just attendance. How will you ensure your guests
                          engage deeply and not just "show up"?{' '}
                          <span className="text-gray-500" data-id="element-3358" data-mp="32f6ukc7axrmd">*</span>
                        </label>
                        <textarea id="engagementPlan" name="engagementPlan" value={formData.engagementPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3359" data-mp="2yc0pv8zu88i0" />
                      </div>
                      <div data-id="element-3360" data-mp="1mv7i4lgt1vyo">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3361" data-mp="1mtwk72a1jifh">
                          Will you be available for a short orientation session
                          before hosting?{' '}
                          <span className="text-gray-500" data-id="element-3362" data-mp="1wkzk40r8hrd6">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3363" data-mp="21iix6xc73y3j">
                          {['Yes, absolutely', "I'll need advance notice", 'Maybe, depending on timing'].map(option => <div key={option} className="flex items-center" data-id="element-3364" data-mp="2alk2ivt8ll65">
                              <input type="radio" id={`orientationAvailability-${option}`} name="orientationAvailability" value={option} checked={formData.orientationAvailability === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3365" data-mp="b7xsn258szcz" />
                              <label htmlFor={`orientationAvailability-${option}`} className="text-gray-700" data-id="element-3366" data-mp="2i2q8927o3s80">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3367" data-mp="2mwkqs2bje15i">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3368" data-mp="2mxcmre91q0wb">
                          Are you willing to document your salon (photos, short
                          recap, highlights) and share them with our team for
                          visibility? <span className="text-gray-500" data-id="element-3369" data-mp="294wh05orforp">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3370" data-mp="244igd8phnh3p">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3371" data-mp="3kiigajoc36qy">
                              <input type="radio" id={`documentationWillingness-${option}`} name="documentationWillingness" value={option} checked={formData.documentationWillingness === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3372" data-mp="3fjxfai19cj1g" />
                              <label htmlFor={`documentationWillingness-${option}`} className="text-gray-700" data-id="element-3373" data-mp="16964t74fmknd">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3374" data-mp="1p1qru7xg9vj9">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3375" data-mp="1p20bldrwj6gi">
                      Final Declaration
                    </h3>
                    <div data-id="element-3376" data-mp="1g9gistyajw3l">
                      <label className="block text-gray-700 font-medium mb-1" data-id="element-3377" data-mp="1g8n7dfoe0if4">
                        I understand that hosting a Networking Salon means
                        representing the brand's values of collaboration,
                        respect, and authenticity.{' '}
                        <span className="text-gray-500" data-id="element-3378" data-mp="2oyqf67ndw1g0">*</span>
                      </label>
                      <div className="space-y-2" data-id="element-3379" data-mp="2ty1xvm7b9h08">
                        {['Yes, I understand and agree', "I'd like to learn more first"].map(option => <div key={option} className="flex items-center" data-id="element-3380" data-mp="2g5vl8a3d9s5j">
                            <input type="radio" id={`agreement-${option}`} name="agreement" value={option} checked={formData.agreement === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3381" data-mp="2k809sueyjylb" />
                            <label htmlFor={`agreement-${option}`} className="text-gray-700" data-id="element-3382" data-mp="2b8mxzv3d2xxf">
                              {option}
                            </label>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2" data-id="element-3383" data-mp="3rnetwhzpunbh">
                  <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-3384" data-mp="3rk93mzfcpfe6">
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
};